// tslint:disable:no-any
import { IPublishTermsResponse } from '../../../../../repositories/billing-tariffs/v1/publish-terms';

export interface IMultiPosting {
  isMultipostingAvailable: boolean;
  multipostingABGroup: string;
}

export const mapMultiposting = (response: IPublishTermsResponse): IMultiPosting => {
  const { multiposting } = response;

  if (!multiposting) {
    return {
      isMultipostingAvailable: false,
      multipostingABGroup: 'A',
    };
  }

  const { enabled: isMultipostingEnabled, group: multipostingABGroup } = multiposting;

  return {
    isMultipostingAvailable: Boolean(isMultipostingEnabled && multipostingABGroup && multipostingABGroup !== 'A'),
    multipostingABGroup: multipostingABGroup || 'A',
  };
};
